
// COMPONENTS
import loginForm from './ps-login-form.js';
import grapeLoginForm from './grape-ps-login-form.js'; /* Deprecated */

export default [
	loginForm,
	grapeLoginForm
];

